import { RestaurantDetails } from 'webReservations/restaurant/apiHelpers';
import { RestaurantEvent } from '@shared/types/restaurants';
import cx from 'classnames';
import typography from '~styles/typography.scss';
import styles from './RestaurantEventPage.scss';

export const RestaurantEventDetailsPageHeader = ({
  event,
  restaurant,
}: {
  event: RestaurantEvent;
  restaurant: RestaurantDetails;
}) => {
  const eventLocationText =
    event.location?.trim() || event.directions?.trim() || null;

  return (
    <header className={styles.pageHeader}>
      <div className={styles.pageMargin}>
        <div className={styles.headerContent}>
          <div className={styles.headerLeft}>
            <div className={typography.h7}>Event</div>

            <h1 className={cx(typography.d3, styles.eventTitle)}>
              {event.name}
            </h1>
            <p className={cx(typography.t1, styles.eventSubtitle)}>
              <span className={cx(styles.eventSubtitleRestaurantName)}>
                {restaurant.name}
              </span>
              {eventLocationText && (
                <span>&nbsp;-&nbsp;{eventLocationText}</span>
              )}
            </p>
          </div>
        </div>
      </div>
    </header>
  );
};
